const i = {
  name: "ProhibitedFill",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 11H10V9H13C13.5477 9 14 9.45228 14 10C14 10.5477 13.5477 11 13 11Z" fill="currentColor"/>
<path d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM10 13H13C14.6523 13 16 11.6523 16 10C16 8.34772 14.6523 7 13 7H8V17H10V13Z" fill="currentColor"/>
</svg>
  `
};
export {
  i as ProhibitedFill
};
